import React from 'react';
import { Skeleton } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

const useSkeltonStyles = makeStyles((theme) => ({
  root: {
    background: theme.skelton?.color,
    margin: theme.spacing(-0.25, 1)
  }
}));

type SkeletonProps = {
  height: number;
  width?: string | number;
  variant?: 'text' | 'circular' | 'rectangular';
};

export const SkeletonRounded: React.FC<SkeletonProps> = ({
  height,
  width,
  variant = 'text'
}: SkeletonProps) => {
  const skelton = useSkeltonStyles();
  return (
    <Skeleton
      data-testid={'skeleton-rounded'}
      classes={skelton}
      variant={variant}
      height={height}
      width={width}
    />
  );
};
